<template>
  <div class="mobile-panel">
    <router-link :to="{name: 'dashboard'}" v-slot="{ isActive }">
      <Button class="p-justify-center" :class="{selected: isActive}">
        <i class="pi pi-table p-mb-1"></i>
        Campaigns
      </Button>
    </router-link>

    <router-link :to="{name: 'campaigns'}" v-slot="{ isActive }">
      <Button class="p-justify-center p-button-link" :class="{selected: isActive}">
        <i class="pi pi-search p-mb-1"></i>
        Explore
      </Button>
    </router-link>

    <router-link :to="{name: 'account.settings'}" v-slot="{ isActive }">
      <Button class="p-justify-center p-button-link" :class="{selected: isActive}">
        <i class="pi pi-user p-mb-1"></i>
        Account
      </Button>
    </router-link>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
@import "../assets/sass/theme_variables";

.mobile-panel {
  display: flex;
  padding: 0 toRem(20);
  border-top: 1px solid $shade300;
  justify-content: space-between;
  background: $bgBlocks;

  .p-button {
    padding-top: toRem(8);
    padding-bottom: toRem(8);
    flex-direction: column;
    background: none;
    color: $textThirdColor;
    border: 0;
    box-shadow: none;
    font-size: toRem(12);

    &.selected {
      color: $primaryColor;
      font-weight: 600;
    }
  }
}
</style>
